module.exports = __webpack_public_path__ + "static/media/empresas.0ec6607a.svg";